import { api } from "@/lib/orgApi";

export const ICD10CM_SYSTEM = "http://hl7.org/fhir/sid/icd-10-cm";

/** Fields stripped by the diagnosis API — must not be displayed in the UI. */
export const INTERNAL_DIAGNOSIS_KEYS = new Set([
  "_id",
  "descriptionSearch",
  "searchText",
  "codePrefix",
  "searchTokens",
  "parentId",
]);

export async function listDiagnosisCodeVersions() {
  const { data } = await api.get("/diagnosis-code-versions");
  return data;
}

export async function searchDiagnosisCodes({
  q,
  versionYear,
  billable,
  active,
  limit = 25,
}) {
  const params = { q, limit };
  if (versionYear != null) params.versionYear = versionYear;
  if (billable != null) params.billable = billable;
  if (active != null) params.active = active;
  const { data } = await api.get("/diagnosis-codes/search", { params });
  return data;
}

export async function getDiagnosisCodeById(id) {
  const { data } = await api.get(`/diagnosis-codes/${encodeURIComponent(id)}`);
  return data;
}

export async function getDiagnosisCodeByCode(code, versionYear) {
  const params = {};
  if (versionYear != null) params.versionYear = versionYear;
  const { data } = await api.get(
    `/diagnosis-codes/by-code/${encodeURIComponent(code)}`,
    { params },
  );
  return data;
}

/** Paginate search results using cumulative fetch (API has limit but no offset). */
export async function searchDiagnosisCodesPage({
  q,
  versionYear,
  billable,
  active,
  page = 1,
  pageSize = 25,
}) {
  const MAX_LIMIT = 100;
  const fetchLimit = Math.min(page * pageSize, MAX_LIMIT);
  const data = await searchDiagnosisCodes({
    q,
    versionYear,
    billable,
    active,
    limit: fetchLimit,
  });
  const start = (page - 1) * pageSize;
  const items = (data.items || []).slice(start, start + pageSize);
  const totalFetched = (data.items || []).length;
  const capped = totalFetched === MAX_LIMIT && fetchLimit === MAX_LIMIT;
  const hasMore =
    !capped &&
    (totalFetched > page * pageSize ||
      (totalFetched === fetchLimit && fetchLimit === page * pageSize));
  return {
    items,
    versionYear: data.versionYear,
    hasMore,
    capped,
    page,
    pageSize,
  };
}

export function pickCurrentVersion(versionsResponse) {
  const items = versionsResponse?.items || [];
  return (
    items.find((v) => v.isCurrent && v.status === "completed") ||
    items.find((v) => v.status === "completed") ||
    null
  );
}
